function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import isMobile from "is-mobile";
import Segments from "/components/segments";
import colors from "/styles/colors";
import { StyledBaseLayoutSegmentComponent } from "./base-layout-segment-component.scss";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withPreviewBaseSegment } from "contexts/preview-base-segment-context";
class BaseLayoutSegmentComponent extends PureComponent {
    getSegmentComponent() {
        const { segment } = this.props;
        return Segments[segment.type];
    }
    getSegmentBackgroundColor() {
        return this.props.segment.props.backgroundColor;
    }
    getSegmentTextColor() {
        return this.props.segment.props.textColor;
    }
    getSegmentStyleOverride() {
        return this.getSegmentComponent().baseSegmentStyleOverride || {};
    }
    getSegmentStyle() {
        const { segment } = this.props;
        let { mobilePaddingTop, mobilePaddingBottom, paddingTop, paddingBottom } = segment.props;
        if (isMobile()) {
            paddingTop = mobilePaddingTop || paddingTop;
            paddingBottom = mobilePaddingBottom || paddingBottom;
        }
        const backgroundColor = colors[this.getSegmentBackgroundColor()];
        const color = colors[this.getSegmentTextColor()];
        const segmentStyleOverride = this.getSegmentStyleOverride();
        return _object_spread({
            backgroundColor,
            color,
            paddingTop,
            paddingBottom
        }, segmentStyleOverride);
    }
    shouldHideSegment() {
        const { segment } = this.props;
        let { showSegment } = segment.props;
        const isMobileMode = isMobile();
        const isMobileOnly = showSegment === "mobile";
        const isDesktopOnly = showSegment === "desktop";
        const shouldHideSegment = isMobileOnly && !isMobileMode || isDesktopOnly && isMobileMode;
        return shouldHideSegment;
    }
    render() {
        const { segment, isUserLoggedIn, extraProps } = this.props;
        const { isFullWidth } = segment.props;
        const SegmentComponent = this.getSegmentComponent();
        if (!SegmentComponent) return null;
        const SegmentComponentWithGenericConfig = withGenericConfig(SegmentComponent);
        const style = this.getSegmentStyle();
        if (this.shouldHideSegment()) {
            // not showing this segment for current mode
            return /*#__PURE__*/ _jsx("div", {
                className: "empty-segment"
            });
        }
        return /*#__PURE__*/ _jsx(StyledBaseLayoutSegmentComponent, {
            className: "base-layout-segment-component",
            style: style,
            children: /*#__PURE__*/ _jsx("div", {
                className: classnames("segment-content-container", {
                    "full-width": isFullWidth
                }),
                children: /*#__PURE__*/ _jsx(SegmentComponentWithGenericConfig, _object_spread_props(_object_spread({}, extraProps, segment.props), {
                    isUserLoggedIn: isUserLoggedIn
                }))
            })
        });
    }
}
BaseLayoutSegmentComponent.defaultProps = {
    extraProps: {}
};
const BaseLayoutSegmentWrapperComponent = (props)=>{
    const { isPreview } = props;
    const Component = isPreview ? withPreviewBaseSegment(BaseLayoutSegmentComponent) : BaseLayoutSegmentComponent;
    return /*#__PURE__*/ _jsx(Component, _object_spread({}, props));
};
export default BaseLayoutSegmentWrapperComponent;
